module.exports = __webpack_public_path__ + "img/dask-zorunlu-deprem-sigortasi.85a61f83.png";